import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ImportLimitsSettings } from "@/components/ImportLimitsSettings";

export default function ImportLimitsCard() {
  return (
    <Card id="import">
      <CardHeader>
        <CardTitle>Import limits</CardTitle>
        <CardDescription>
          Configure limits for page imports and key content
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ImportLimitsSettings />
      </CardContent>
    </Card>
  );
}
